import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import SEOHead from './components/SEOHead';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Industries from './components/Industries';
import Experience from './components/Experience';
import CaseStudies from './components/CaseStudies';
import Achievements from './components/Achievements';
import Testimonials from './components/Testimonials';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import QuoteModal from './components/QuoteModal';
import AdminPanel from './pages/AdminPanel';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import GalleryPage from './pages/GalleryPage';
import SourcingHubPage from './pages/SourcingHubPage';
import SourcingTechniquePage from './pages/SourcingTechniquePage';
import FAQPage from './pages/FAQPage';
import BiographyPage from './pages/BiographyPage';
import CareerPage from './pages/CareerPage';
import RecruiterIQPage from './pages/RecruiterIQPage';
import { Toaster } from './components/ui/toaster';
import { ThemeProvider } from './contexts/ThemeContext';

const HomePage = () => (
  <>
    <SEOHead />
    <QuoteModal />
    <Header />
    <Hero />
    <About />
    <Industries />
    <Experience />
    <Achievements />
    <CaseStudies />
    <Testimonials />
    <Services />
    <Contact />
    <Footer />
  </>
);

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/sourcing-hub" element={<SourcingHubPage />} />
            <Route path="/sourcing-hub/:slug" element={<SourcingTechniquePage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/biography" element={<BiographyPage />} />
            <Route path="/career" element={<CareerPage />} />
            <Route path="/recruiteriq" element={<RecruiterIQPage />} />
          </Routes>
          <Toaster />
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
